import { render, staticRenderFns } from "./FacebookFeed.vue?vue&type=template&id=2661b238&"
import script from "./FacebookFeed.vue?vue&type=script&lang=js&"
export * from "./FacebookFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2661b238', component.options)
    } else {
      api.reload('2661b238', component.options)
    }
    module.hot.accept("./FacebookFeed.vue?vue&type=template&id=2661b238&", function () {
      api.rerender('2661b238', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/FacebookFeed.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/FacebookFeed.vue
// module id = 128
// module chunks = 7